import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Dropdown } from 'primereact/dropdown'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import { enums } from '../../constants'
import utils from '../../utils/index'
import apiService from '../../services/api.service'
import '../../index.scss'
import './DataTableWebhookPixAutomaticoCallbackItem.scss'

const TIPO_OPTIONS = [
  { label: 'Recorrência', value: 'REC' },
  { label: 'Cobrança', value: 'COBR' },
]
const CODIGO_PSP_OPTIONS = [
  { label: 'Banco do Brasil', value: 'BB' },
  { label: 'Bradesco', value: 'BRADESCO' },
]
const STATUS_OPTIONS = [
  { label: 'Pendente', value: 'PENDENTE' },
  { label: 'Processando', value: 'PROCESSANDO' },
  { label: 'Processado', value: 'PROCESSADO' },
  { label: 'Erro', value: 'ERRO' },
  { label: 'Ignorado', value: 'IGNORADO' },
]

export class DataTableWebhookPixAutomaticoCallbackItem extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      webhookFilters: [],
      filtros: {
        tipo: null,
        codigoPsp: null,
        status: null,
      },
      webhookSortField: {},
      webhookInfo: {
        index: 0,
        max: 15,
        count: 0,
        page: 0,
      },
      records: [],
      itemSelecionado: null,
      colunas: [
        {
          field: 'dataCriacao',
          header: 'Data',
          columnKey: 'dataCriacao',
          sortable: true,
          filter: false,
          columnSortField: 'dataCriacao',
          visible: true,
          fieldFormatter: 'formatarDataHoraCompleta',
        },
        {
          field: 'tipoDescricao',
          header: 'Tipo',
          columnKey: 'tipoDescricao',
          sortable: true,
          filter: true,
          columnSortField: 'callback.tipo',
          visible: true,
        },
        {
          field: 'codigoPspDescricao',
          header: 'PSP',
          columnKey: 'codigoPspDescricao',
          sortable: true,
          filter: true,
          columnSortField: 'callback.codigoPsp',
          visible: true,
        },
        {
          field: 'statusDescricao',
          header: 'Status',
          columnKey: 'statusDescricao',
          sortable: true,
          filter: true,
          columnSortField: 'status',
          visible: true,
        },
        {
          field: 'statusPsp',
          header: 'Status no PSP',
          columnKey: 'statusPsp',
          sortable: false,
          filter: false,
          visible: true,
        },
        {
          field: 'mensagemErro',
          header: 'Erro',
          columnKey: 'mensagemErro',
          sortable: false,
          filter: false,
          visible: true,
        },
        {
          field: 'tentativas',
          header: 'Tentativas',
          columnKey: 'tentativas',
          sortable: false,
          filter: false,
          visible: true,
        },
        {
          field: 'dataProcessamento',
          header: 'Processado em',
          columnKey: 'dataProcessamento',
          sortable: true,
          filter: false,
          columnSortField: 'dataProcessamento',
          visible: true,
          fieldFormatter: 'formatarDataHoraCompleta',
        },
      ],
    }
  }

  buildFiltersFromFiltros = (filtros) => {
    const webhookFilters = []
    if (filtros.tipo) {
      webhookFilters.push({ campo: 'callback.tipo', valor: filtros.tipo, tipoFiltro: 'IGUAL_A' })
    }
    if (filtros.codigoPsp) {
      webhookFilters.push({ campo: 'callback.codigoPsp', valor: filtros.codigoPsp, tipoFiltro: 'IGUAL_A' })
    }
    if (filtros.status) {
      webhookFilters.push({ campo: 'status', valor: filtros.status, tipoFiltro: 'IGUAL_A' })
    }
    return webhookFilters
  }

  onFilterDropdown = (field, value) => {
    const filtros = { ...this.state.filtros, [field]: value }
    const webhookFilters = this.buildFiltersFromFiltros(filtros)
    this.setState({ filtros, webhookFilters })

    const params = {
      filters: webhookFilters,
      pagination: {
        index: 0,
        max: this.state.webhookInfo.max || 15,
      },
      sortField: null,
    }
    this.executeFilter(params)
  }

  onSort = (e) => {
    const sortParams = { order: e.sortOrder, field: e.sortField }
    this.setState({ webhookSortField: sortParams })

    const params = {
      filters: this.state.webhookFilters,
      pagination: {
        index: 0,
        max: this.state.webhookInfo.max || 15,
      },
      sortField: sortParams,
    }
    this.executeFilter(params)
  }

  onPage = (e) => {
    const params = {
      filters: this.state.webhookFilters,
      pagination: {
        index: e.first,
        max: e.rows,
      },
      sortField: null,
    }
    this.executeFilter(params)
  }

  executeFilter = (params) => {
    const filters = [...(params.filters || [])]
    filters.push({ campo: 'txid', valor: this.props.txid, tipoFiltro: 'IGUAL_A' })

    const requestParam = {
      index: params.pagination.index,
      max: params.pagination.max,
      filters,
      sortFields: params.sortField
        ? [{ fieldName: params.sortField.field, order: params.sortField.order > -1 ? 'ASC' : 'DESC' }]
        : [{ fieldName: 'dataCriacao', order: 'DESC' }],
    }

    apiService
      .post(`/lottustech/webhook/pixautomatico/callback-item/all`, requestParam)
      .then((response) => {
        const size = response.data.size || 15
        const max = response.data.size || 15
        const page = response.data.page || 1
        const index = page * max - size
        const webhookInfo = {
          index: index,
          max: max,
          count: response.data.count || 0,
          page: page,
        }
        this.setState({ records: response.data.records, webhookInfo })
      })
      .catch((err) => {
        if (err.response) {
          console.log(err.response.data)
        }
      })
  }

  formatColumn = (rowData, column) => {
    return utils.format(rowData, column)
  }

  statusTemplate = (rowData) => {
    if (!rowData) return null
    const status = rowData.status
    const className = `status-badge status-${status ? status.toLowerCase() : 'pendente'}`
    return <span className={className}>{rowData.statusDescricao}</span>
  }

  formatItemData = (itemData) => {
    if (!itemData) return ''
    try {
      return JSON.stringify(JSON.parse(itemData), null, 2)
    } catch (e) {
      return itemData
    }
  }

  detalhesTemplate = (rowData) => (
    <Button
      icon="pi pi-eye"
      className="p-button-text"
      title="Detalhes"
      onClick={() => this.setState({ itemSelecionado: rowData })}
    />
  )

  tipoFilter = () => (
    <Dropdown
      style={{ width: '100%' }}
      value={this.state.filtros.tipo}
      options={TIPO_OPTIONS}
      showClear
      onChange={(e) => this.onFilterDropdown('tipo', e.value)}
    />
  )

  codigoPspFilter = () => (
    <Dropdown
      style={{ width: '100%' }}
      value={this.state.filtros.codigoPsp}
      options={CODIGO_PSP_OPTIONS}
      showClear
      onChange={(e) => this.onFilterDropdown('codigoPsp', e.value)}
    />
  )

  statusFilter = () => (
    <Dropdown
      style={{ width: '100%' }}
      value={this.state.filtros.status}
      options={STATUS_OPTIONS}
      showClear
      onChange={(e) => this.onFilterDropdown('status', e.value)}
    />
  )

  componentDidMount() {
    if (!this.props.txid) {
      return
    }
    this.executeFilter({ filters: [], pagination: { index: 0, max: 15 } })
  }

  renderColunas = () => {
    return this.state.colunas.map((col) => {
      col.showFilterMenuOptions = false
      col.showClearButton = false
      col.showFilterMenu = false

      if (col.field === 'dataCriacao' || col.field === 'dataProcessamento') {
        return (
          <Column {...col} key={col.field} field={col.field} sortField={col.columnSortField} body={this.formatColumn} />
        )
      }
      if (col.field === 'tipoDescricao') {
        return (
          <Column
            {...col}
            key={col.field}
            field={col.field}
            sortField={col.columnSortField}
            filterElement={this.tipoFilter()}
          />
        )
      }
      if (col.field === 'codigoPspDescricao') {
        return (
          <Column
            {...col}
            key={col.field}
            field={col.field}
            sortField={col.columnSortField}
            filterElement={this.codigoPspFilter()}
          />
        )
      }
      if (col.field === 'statusDescricao') {
        return (
          <Column
            {...col}
            key={col.field}
            field={col.field}
            sortField={col.columnSortField}
            body={this.statusTemplate}
            filterElement={this.statusFilter()}
          />
        )
      }
      return <Column {...col} key={col.field} field={col.field} sortField={col.columnSortField} />
    })
  }

  render() {
    if (!this.props.txid) {
      return null
    }

    return (
      <div>
        <DataTable
          filter={true}
          filterDisplay="row"
          onPage={this.onPage}
          paginator={true}
          rows={this.state.webhookInfo.max}
          rowsPerPageOptions={enums.ROWSPERPAGEOPTIONS}
          onSort={this.onSort}
          value={this.state.records}
          sortOrder={this.state.webhookSortField.order}
          sortField={this.state.webhookSortField.field}
          emptyMessage={' '}
          lazy={true}
          first={this.state.webhookInfo.index}
          totalRecords={this.state.webhookInfo.count}
          size={'small'}
          stripedRows
          resizableColumns
          columnResizeMode="fit"
          responsiveLayout="scroll"
        >
          {this.renderColunas()}
          <Column key="detalhes" header="Detalhes" body={this.detalhesTemplate} />
        </DataTable>

        <Dialog
          header="Detalhes do evento"
          visible={!!this.state.itemSelecionado}
          onHide={() => this.setState({ itemSelecionado: null })}
          style={{ width: '50vw' }}
        >
          {this.state.itemSelecionado ? (
            <div>
              {this.state.itemSelecionado.mensagemErro ? (
                <p>
                  <strong>Erro:</strong> {this.state.itemSelecionado.mensagemErro}
                </p>
              ) : null}
              <pre>{this.formatItemData(this.state.itemSelecionado.itemData)}</pre>
            </div>
          ) : null}
        </Dialog>
      </div>
    )
  }
}
